/**
 * The grace dialog opens once per session (TMMAPP-0116): a per-tab flag, the `returnTo` pattern —
 * sessionStorage with an in-memory fallback. A UI convenience, never authority.
 */
const GRACE_SHOWN_KEY = 'tmm_subscribe_grace_shown';
let memory = false;

export function graceShown(): boolean {
  if (memory) return true;
  try {
    return sessionStorage.getItem(GRACE_SHOWN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markGraceShown(): void {
  memory = true;
  try {
    sessionStorage.setItem(GRACE_SHOWN_KEY, '1');
  } catch {
    // sessionStorage may be unavailable (private mode / quota) — memory still holds it.
  }
}

/** Test helper — forget that the grace dialog was shown this session. */
export function clearGraceShownForTests(): void {
  memory = false;
  try {
    sessionStorage.removeItem(GRACE_SHOWN_KEY);
  } catch {
    // ignore
  }
}
